import { type FC } from 'react';
import { DialogClose, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ModalId, useCurrentModalProps } from '@/hooks/data/modal/useModalStore';
import { Modal, ModalContent } from '@/components/ui/modal';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Button } from '@/components/ui/button';
import { useTranslations } from 'next-intl';

export const NoteDialog: FC = () => {
  const modalData = useCurrentModalProps(ModalId.AssetNote);
  const note = modalData?.note ?? '';
  const tCommon = useTranslations('common');
  const tDialogs = useTranslations('dialogs');

  return (
    <Modal id={ModalId.AssetNote}>
      <ModalContent onPointerDownOutside={(e) => e.preventDefault()} className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>{tDialogs('assetNoteTitle')}</DialogTitle>
        </DialogHeader>
        <ScrollArea className="max-h-[calc(100vh-15rem)] overflow-y-auto whitespace-pre-line">
          <DialogDescription className="bg-ui-panel px-3 py-6 text-base break-all text-text-gray">
            {note}
          </DialogDescription>
        </ScrollArea>
        <DialogFooter>
          <DialogClose asChild autoFocus>
            <Button variant="secondary" data-cy="note-dismiss-button">
              {tCommon('close')}
            </Button>
          </DialogClose>
        </DialogFooter>
      </ModalContent>
    </Modal>
  );
};
